import { render, staticRenderFns } from "./SegmentCard.vue?vue&type=template&id=fc57887e&lang=pug&"
import script from "./SegmentCard.vue?vue&type=script&lang=js&"
export * from "./SegmentCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports